const escapeHtml = (text) => text.replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`)

// Digits as compared against the stored E.164 numbers, see admin2 Tantum::Client.phone_search_digits
export function phoneSearchDigits(searchString) {
  const term = String(searchString || '').trim()
  let digits = term.replace(/\D/g, '')
  if (/^(\+|0049)/.test(term)) digits = digits.replace(/^(00)?49/, '')
  return digits.replace(/^0+/, '')
}

export function isPhoneSearch(searchString) {
  return /^[\d\s+\-/()]+$/.test(String(searchString || '')) && phoneSearchDigits(searchString).length >= 4
}

// Marks the searched digits inside the formatted number ("038233 6<mark>17-0</mark>"), skipping
// spaces/dashes. Candidates (other extension) only share a prefix: shorten the digits until they match.
export function highlightPhone(number, searchString) {
  const text = String(number || '')
  const searchDigits = phoneSearchDigits(searchString)
  const positions = [...text].flatMap((char, i) => /\d/.test(char) ? [i] : [])
  const digits = positions.map(i => text[i]).join('')
  for (let length = searchDigits.length; length >= 4; length--) {
    const start = digits.indexOf(searchDigits.slice(0, length))
    if (start >= 0) {
      // searchDigits drop the trunk 0, but "038233…" should be marked from its 0
      const from = start === 1 && digits[0] === '0' ? positions[0] : positions[start]
      const to = positions[start + length - 1] + 1
      return escapeHtml(text.slice(0, from)) + '<mark class="highlight">' +
        escapeHtml(text.slice(from, to)) + '</mark>' + escapeHtml(text.slice(to))
    }
  }
  return escapeHtml(text)
}
